// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f5335435","703":"96a3f55c","787":"cda612ba"}[chunkId] + ".chunk.js";
};